module.exports = {
	AdjustMainChatZorder  : "ChatEvent.AdjustMainChatZorder",     // 调整左下角聊天ZOrder
	UpdatePrivateCoseList : "ChatEvent.UpdatePrivateCoseList",    // 刷新私聊聊天列表
	UpdatePrivateChatRed  : "ChatEvent.UpdatePrivateChatRed",     // 刷新私聊红点
	EndCallBack           : "ChatEvent.EndCallBack",              // 延迟创建完
	AdjustMainChatBtnPos  : "ChatEvent.AdjustMainChatBtnPos",     // 刷新左侧按钮位置
	MassageUpdate         : "ChatEvent.MassageUpdate",            // 消息更新
	MassageDelete         : "ChatEvent.MassageDelete",            // 消息删除
	PrivateMassageUpdate  : "ChatEvent.PrivateMassageUpdate",     // 私聊消息更新
	PrivateMassageDelete  : "ChatEvent.PrivateMassageDelete",     // 私聊消息删除
	CHAT_SELECT_ITEM      : "ChatEvent.CHAT_SELECT_ITEM",         // 选中Item
}